import {Injectable} from '@angular/core';
import {CrudService} from '../crud/crud.service';
import {Spring} from '../spring/spring';

@Injectable({
  providedIn: 'root'
})
export class NotasService {

  constructor(private crud: CrudService, private spring: Spring) {
  }

  postNota(nota: any) {
    return this.crud.post(`${this.spring.NOTAS}`, nota);
  }
}
